import React from 'react';
import axios from 'axios';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import ProductionApp from './mrp/ProductionApp';
import './YkHomePortal.css';

const SESSION_KEY = 'yk_portal_session';

function readSession() {
  try {
    const value = window.localStorage.getItem(SESSION_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

function PortalLogin({ onLogin }) {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/login', {
        username: username.trim(),
        password,
      });
      onLogin({ user: response.data.user, token: response.data.token });
    } catch (requestError) {
      setError(
        requestError.response?.data?.error ||
          'Serverul nu poate fi contactat. Verifică dacă aplicația este pornită.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="ykh-shell ykh-loginShell">
      <section className="ykh-loginCard" aria-labelledby="ykh-login-title">
        <img className="ykh-logo" src="/ykhome/logo-yk-cu-an.png" alt="Younger Karom" />
        <p className="ykh-eyebrow">Portal intern</p>
        <h1 id="ykh-login-title">Bine ai revenit</h1>
        <p className="ykh-muted">Autentifică-te cu datele contului tău personal.</p>

        <form className="ykh-form" onSubmit={handleSubmit}>
          <label>
            Nume utilizator
            <input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              required
            />
          </label>
          <label>
            Parolă
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error && <div className="ykh-error">{error}</div>}
          <button className="ykh-primaryButton" type="submit" disabled={loading}>
            {loading ? 'Se conectează…' : 'Intră în hub'}
          </button>
        </form>

        <a className="ykh-publicLink" href="/">
          ← Înapoi la site
        </a>
      </section>
    </main>
  );
}

function PortalHub({ session, onLogout }) {
  const navigate = useNavigate();

  return (
    <main className="ykh-shell">
      <header className="ykh-hubHeader">
        <div>
          <p className="ykh-eyebrow">YK Home</p>
          <h1>Hub aplicații</h1>
          <p className="ykh-muted">
            Conectat ca <strong>{session.user.username}</strong> · {session.user.role}
          </p>
        </div>
        <div className="ykh-headerActions">
          <a className="ykh-secondaryButton" href="/">
            Site public
          </a>
          <button className="ykh-secondaryButton" type="button" onClick={onLogout}>
            Deconectare
          </button>
        </div>
      </header>

      <section className="ykh-appGrid" aria-label="Aplicații disponibile">
        <button
          className="ykh-appCard"
          type="button"
          onClick={() => navigate('/ykhome/productie')}
        >
          <span className="ykh-appIcon" aria-hidden="true">YK</span>
          <span>
            <strong>Sistem de Planificare a Producției</strong>
            <small>Clienți, produse, calendar, operatori și setări</small>
          </span>
          <span className="ykh-arrow" aria-hidden="true">→</span>
        </button>
      </section>
    </main>
  );
}

export default function YkHomePortal() {
  const [session, setSession] = React.useState(readSession);
  const navigate = useNavigate();

  function handleLogin(nextSession) {
    window.localStorage.setItem(SESSION_KEY, JSON.stringify(nextSession));
    setSession(nextSession);
    navigate('/ykhome', { replace: true });
  }

  function handleLogout() {
    window.localStorage.removeItem(SESSION_KEY);
    setSession(null);
    navigate('/ykhome', { replace: true });
  }

  return (
    <Routes>
      <Route
        index
        element={
          session ? (
            <PortalHub session={session} onLogout={handleLogout} />
          ) : (
            <PortalLogin onLogin={handleLogin} />
          )
        }
      />
      <Route
        path="productie/*"
        element={
          session ? (
            <ProductionApp
              session={session}
              onLogout={handleLogout}
              onBackToHub={() => navigate('/ykhome')}
            />
          ) : (
            <Navigate to="/ykhome" replace />
          )
        }
      />
      <Route path="*" element={<Navigate to="/ykhome" replace />} />
    </Routes>
  );
}
